



























































































import {Emit} from "vue-property-decorator";
import {Stored} from "vue-stored-prop-decorator";
import {Component} from '@/shared/component';
import {AbstractShowVue} from '@/components/Abstract/AbstractShowVue';
import {Tache, Token} from '@/models';

import storeTache from '@/stores/modules/tache';
import storeToken from "@/stores/modules/token";

import CrudTacheEditDialog from '@/components/Crud/Tache/EditDialog.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

@Component({
	components: {
		CrudTacheEditDialog,
		CrudDeleteDialog,
	}
})
export default class CrudTacheShow extends AbstractShowVue<Tache> {

	private imgPath: string = "";

	private editTache: Tache = null;

	@Stored(() => storeToken)
	private token: Token;

	public constructor() {
		super(storeTache);
	}

	public async mounted(): Promise<void> {
		await super.mounted();
	}

	public async refresh(value: any): Promise<void> {
		await super.refresh(value);

		if (this.item !== null)
		{
			this.imgPath = "/img/files/proprietaire.jpg";

			if (this.$route.name === 'tache-show') {
				this.$route.meta.title = 'Détails  d\'un tache';
			}
		}

	}


}
